import { fetchBaseQuery, retry } from "@reduxjs/toolkit/dist/query"
import { currentUrl } from "../../url"

export const BASE_URL = currentUrl

export function getApiConfig() {
  // const BASE_URL = "//127.0.0.1:8000/api/v1/"

  function prepareHeaders(headers) {
    const accessToken = localStorage.getItem("accessToken")
    if (accessToken) {
      // Ensure consistent token format
      const token = accessToken.startsWith('Bearer ') ? accessToken : `Bearer ${accessToken}`
      headers.set("Authorization", token)
    }
    headers.set("Content-Type", "application/json")
    headers.set("Accept", "application/json")
    // Add these headers to help with CORS issues in Safari
    headers.set("Origin", window.location.origin)
    return headers
  }

  return {
    BASE_URL,
    accessToken: localStorage.getItem("accessToken"),
    prepareHeaders,
  }
}

export function baseQueryWithReauth({baseUrl, prepareHeaders, retriesCount = 3}) {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders,
  })
  
  // Custom wrapper to handle 401 errors more gracefully
  return async (args, api, extraOptions) => {
    try {
      const result = await retry(baseQuery, {maxRetries: retriesCount})(args, api, extraOptions)
      
      // Handle 401 errors specifically
      if (result.error && result.error.status === 401) {
        // Clear tokens from localStorage
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        // Dispatch a logout action if needed
        // api.dispatch(logout())
      }
      
      return result
    } catch (error) {
      if (error.status === 401) {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        window.location.reload()
      }
      throw error
    }
  }
}